import { AppConsts } from './shared/AppConsts';
import { XmlHttpRequestHelper } from './shared/helpers/XmlHttpRequestHelper';

export class AppPreBootstrap {
  static run(appRootUrl?: string): Promise<void> {
    return new Promise<void>((resolve) => {
      const rootUrl = appRootUrl || AppPreBootstrap.getAppRootUrl();
      AppPreBootstrap.getApplicationConfig(rootUrl, () => {
        resolve();
      });
    });
  }

  private static getAppRootUrl(): string {
    const base = document.baseURI || window.location.origin + '/';
    return base.endsWith('/') ? base : `${base}/`;
  }

  private static getApplicationConfig(appRootUrl: string, callback: () => void): void {
    const isLocalhost =
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1';

    const configFiles = isLocalhost
      ? ['appconfig.json', 'appconfig.production.json']
      : ['appconfig.production.json', 'appconfig.json'];

    const tryLoad = (index: number) => {
      if (index >= configFiles.length) {
        // Fallback completed with default AppConsts
        AppPreBootstrap.loadGoogleMapsScript(AppConsts.googleMapApiKey, callback);
        return;
      }

      const configFile = configFiles[index];
      const url = `${appRootUrl}assets/${configFile}`;

      XmlHttpRequestHelper.ajax(
        'GET',
        url,
        null,
        null,
        (result) => {
          if (result) {
            let parsed = result;
            if (typeof result === 'string') {
              try {
                parsed = JSON.parse(result);
              } catch {
                try {
                  // Support base64 obfuscated config if needed
                  parsed = JSON.parse(atob(result));
                } catch {
                  parsed = {};
                }
              }
            }

            const baseUrl = (parsed.apiBaseUrl || parsed.remoteServiceBaseUrl || '').trim().replace(/\/+$/, '');
            const remoteBaseUrl = (parsed.remoteServiceBaseUrl || baseUrl).trim().replace(/\/+$/, '');
            if (baseUrl) {
              AppConsts.apiBaseUrl = baseUrl;
              AppConsts.remoteServiceBaseUrl = remoteBaseUrl;
            }
            if (parsed.appBaseUrl) {
              AppConsts.appBaseUrl = parsed.appBaseUrl;
            }
            if (parsed.googleMapApiKey) {
              AppConsts.googleMapApiKey = parsed.googleMapApiKey;
            }
            Object.assign(AppConsts, parsed);
            if (baseUrl) {
              AppConsts.apiBaseUrl = baseUrl;
              AppConsts.remoteServiceBaseUrl = remoteBaseUrl;
            }
          }
          AppPreBootstrap.loadGoogleMapsScript(AppConsts.googleMapApiKey, callback);
        },
        () => {
          // If this file was not found, try next candidate
          tryLoad(index + 1);
        }
      );
    };

    tryLoad(0);
  }

  private static loadGoogleMapsScript(apiKey: string, callback: () => void): void {
    if (!apiKey || (window as any).google?.maps) {
      callback();
      return;
    }
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&language=en`;
    script.async = true;
    script.defer = true;
    script.onload = () => callback();
    script.onerror = () => callback();
    document.head.appendChild(script);
  }
}
